import React from "react";
import {
    EmailShareButton,
    FacebookShareButton,
    InstapaperShareButton,
    LinkedinShareButton,
    TelegramShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
import toastr from "toastr";

export default function SharePop(props) {
    const { onClose, shareUrl, title, subTitle, image, heading } = props;

    return (
        <div
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            className="w-full"
        >
            {
                heading && <div className="flex items-center justify-between pb-1.5 border-b border-black-10 mb-3.5">
                    <h3 className="text-base font-bold text-ebony-color">
                        {heading}
                    </h3>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onClose();
                        }}
                        className="p-1.5 ring-1 flex justify-center items-center ring-black-10 hover:ring-orange-color rounded-md mb-2 bg-white duration-150 text-black-50 hover:text-orange-color"
                    >
                        <svg
                            width="12"
                            height="12"
                            className="stroke-current "
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1 11L11 1M1 1L11 11"
                                strokeWidth="1.26316"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            }


            <div className="flex items-center gap-x-2.5 mb-4">
                <img src={image} className="w-10 h-10 rounded-full" alt="" />
                <div className="">
                    <h1 className="text-sm font-medium text-ebony-color">
                        {title}
                    </h1>
                    <p className="text-sm text-ebony-color/70">{subTitle}</p>
                </div>
            </div>

            <div className="text-sm font-medium text-black-80 mb-2.5">
                <h5 className=" mb-1.5">Share this link via</h5>

                <div className="flex justify-between items-center mb-5">
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#1579E9] cursor-pointer">
                        <FacebookShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="7"
                                height="14"
                                viewBox="0 0 7 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4.38031 5.18597V3.87774C4.38031 3.31084 4.51113 3.00558 5.42689 3.00558H6.56069V0.825195H4.81638C2.636 0.825195 1.76384 2.26425 1.76384 3.87774V5.18597H0.0195312V7.36636H1.76384V13.9075H4.38031V7.36636H6.29905L6.56069 5.18597H4.38031Z"
                                    fill="#1579E9"
                                />
                            </svg>
                        </FacebookShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#55ACEE] bg-[#55ACEE] cursor-pointer">
                        <TwitterShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M17.6585 2.72362C17.0009 3.08045 16.3034 3.31467 15.5892 3.41849C16.3332 2.87234 16.9044 2.00749 17.1733 0.97703C16.4661 1.49107 15.6924 1.85325 14.8855 2.04791C14.2283 1.19028 13.292 0.654297 12.2557 0.654297C10.266 0.654297 8.65281 2.63019 8.65281 5.0672C8.65281 5.41312 8.68471 5.74989 8.74611 6.07296C5.75184 5.88886 3.09713 4.13202 1.32013 1.4621C1.01007 2.11386 0.8324 2.87201 0.8324 3.68065C0.8324 5.21172 1.4685 6.56239 2.43517 7.35381C1.86304 7.33186 1.30349 7.14258 0.803246 6.80177C0.80304 6.82026 0.80304 6.83875 0.80304 6.85731C0.80304 8.99545 2.04492 10.7791 3.69304 11.1845C3.1625 11.3612 2.606 11.3871 2.06605 11.2601C2.52448 13.0134 3.85506 14.2892 5.43156 14.3249C4.19853 15.5084 2.64501 16.214 0.957109 16.214C0.666258 16.214 0.379522 16.1931 0.0976562 16.1523C1.69206 17.4044 3.58582 18.135 5.62041 18.135C12.2474 18.135 15.8711 11.4105 15.8711 5.57898C15.8711 5.38758 15.8677 5.19727 15.8607 5.00805C16.5661 4.38349 17.1748 3.60991 17.6585 2.72362"
                                    fill="white"
                                />
                            </svg>
                        </TwitterShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#1579E9] cursor-pointer">
                        <TelegramShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="16"
                                height="13"
                                viewBox="0 0 16 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.278 0.305371L14.3911 0.555366C14.6098 0.45645 14.7734 0.500187 14.8631 0.5869C14.9565 0.677162 15.049 0.890739 14.9498 1.28823L14.9497 1.28819L14.9477 1.29768L12.7387 11.7083L12.7385 11.7093C12.6689 12.0429 12.5502 12.167 12.459 12.2081C12.3678 12.2491 12.2039 12.2527 11.9344 12.1077L8.58451 9.63338L8.39717 9.495L8.2302 9.65737L6.61314 11.2298L6.6124 11.2305L6.60641 11.2363C6.53177 11.3084 6.47998 11.3584 6.42941 11.3961L6.62596 8.45913L12.7853 2.90031C12.7856 2.90004 12.7859 2.89977 12.7862 2.8995C12.87 2.82492 12.9719 2.70667 12.9779 2.54983C12.9812 2.4614 12.9523 2.37656 12.8956 2.30905C12.8426 2.24587 12.7763 2.21056 12.7197 2.19111C12.6096 2.15331 12.4884 2.1582 12.3822 2.1802C12.2708 2.2033 12.1525 2.24988 12.0369 2.32021L12.0369 2.32018L12.0331 2.32256L4.43397 7.11711L1.22422 6.11583L1.223 6.11545C1.06681 6.06753 0.975203 6.01196 0.929099 5.96835C0.907243 5.94769 0.899479 5.93342 0.897035 5.92774C0.895276 5.92366 0.895409 5.92245 0.89553 5.92135L0.895554 5.92112C0.895968 5.91701 0.903405 5.87358 0.986876 5.79977C1.06835 5.72773 1.20301 5.64482 1.40549 5.56333L14.3768 0.561384L14.278 0.305371Z"
                                    fill="#0F7CBD"
                                    stroke="#0F7CBD"
                                    strokeWidth="0.548777"
                                />
                            </svg>
                        </TelegramShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#1579E9] bg-[#1579E9] cursor-pointer">
                        <EmailShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="16"
                                height="13"
                                viewBox="0 0 16 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.1338 0.329102H0.8652C0.561648 0.329102 0.316406 0.574344 0.316406 0.877895V11.8538C0.316406 12.1573 0.561648 12.4026 0.8652 12.4026H15.1338C15.4374 12.4026 15.6826 12.1573 15.6826 11.8538V0.877895C15.6826 0.574344 15.4374 0.329102 15.1338 0.329102ZM13.7481 2.19671L8.33737 6.40699C8.2036 6.5116 8.01666 6.5116 7.8829 6.40699L2.47042 2.19671C2.45002 2.18097 2.43505 2.15923 2.42762 2.13455C2.42019 2.10988 2.42067 2.08349 2.42899 2.0591C2.43731 2.03471 2.45306 2.01353 2.47402 1.99853C2.49498 1.98354 2.52011 1.97548 2.54588 1.97548H13.6727C13.6984 1.97548 13.7236 1.98354 13.7445 1.99853C13.7655 2.01353 13.7812 2.03471 13.7896 2.0591C13.7979 2.08349 13.7984 2.10988 13.7909 2.13455C13.7835 2.15923 13.7685 2.18097 13.7481 2.19671V2.19671Z"
                                    fill="white"
                                />
                            </svg>
                        </EmailShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#2FE664] cursor-pointer">
                        <WhatsappShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="18"
                                height="19"
                                viewBox="0 0 18 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.2091 3.13793C14.404 2.32538 13.4452 1.68119 12.3887 1.24289C11.3321 0.804598 10.1989 0.580961 9.05509 0.585015C4.26208 0.585015 0.355884 4.49011 0.351493 9.28423C0.351493 10.8197 0.753198 12.3135 1.51161 13.636L0.28125 18.1459L4.89537 16.9364C6.17183 17.631 7.60186 17.9951 9.05509 17.9955H9.05948C13.8536 17.9955 17.7587 14.0904 17.7631 9.29191C17.7642 8.14831 17.539 7.01579 17.1005 5.9596C16.6619 4.90342 16.0188 3.94444 15.208 3.13793H15.2091ZM9.05509 16.5226C7.75888 16.523 6.48649 16.1742 5.3717 15.5128L5.10829 15.3548L2.37099 16.0726L3.10196 13.4022L2.93074 13.1268C2.20615 11.9747 1.82293 10.6408 1.82551 9.27984C1.82551 5.30011 5.07097 2.05354 9.05948 2.05354C10.0097 2.05184 10.9508 2.23823 11.8286 2.60198C12.7065 2.96573 13.5036 3.49963 14.1741 4.17292C14.8469 4.84358 15.3803 5.64081 15.7435 6.51864C16.1067 7.39647 16.2925 8.33753 16.2902 9.28752C16.2858 13.2815 13.0403 16.5226 9.05509 16.5226V16.5226ZM13.0228 11.1073C12.8065 10.9986 11.7386 10.4729 11.5378 10.3982C11.338 10.3269 11.192 10.2896 11.0493 10.5069C10.9034 10.7231 10.4863 11.2159 10.3612 11.3575C10.2361 11.5035 10.1066 11.5199 9.88924 11.4124C9.67302 11.3026 8.97168 11.0743 8.14193 10.3313C7.49437 9.75508 7.06084 9.04167 6.93133 8.82545C6.80621 8.60813 6.91925 8.49179 7.02791 8.38313C7.1234 8.28655 7.24413 8.1285 7.35279 8.00338C7.46254 7.87826 7.49876 7.78606 7.5701 7.64119C7.64145 7.49412 7.60742 7.36899 7.55364 7.26034C7.49876 7.15168 7.06523 6.07937 6.88194 5.64693C6.70633 5.21998 6.52743 5.27925 6.39353 5.27376C6.26841 5.26608 6.12243 5.26608 5.97646 5.26608C5.86622 5.26882 5.75774 5.29432 5.65783 5.34097C5.55792 5.38762 5.46872 5.45442 5.39585 5.53718C5.1961 5.75449 4.63744 6.28022 4.63744 7.35253C4.63744 8.42484 5.4167 9.45544 5.52646 9.60142C5.63402 9.74739 7.05645 11.9414 9.23948 12.8853C9.75533 13.1103 10.1614 13.2431 10.4786 13.3441C11 13.5109 11.4708 13.4857 11.8462 13.4319C12.2632 13.3682 13.1314 12.9051 13.3147 12.3969C13.4947 11.8876 13.4947 11.453 13.4398 11.3619C13.386 11.2697 13.2401 11.2159 13.0228 11.1073V11.1073Z"
                                    fill="#2FE664"
                                />
                            </svg>
                        </WhatsappShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#007EBB] bg-[#007EBB] cursor-pointer">
                        <LinkedinShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="16"
                                height="15"
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.24067 5.14822H8.95829V6.50191C9.34977 5.72335 10.3537 5.02382 11.8618 5.02382C14.7528 5.02382 15.4392 6.57362 15.4392 9.4171V14.6833H12.5123V10.0647C12.5123 8.44537 12.1208 7.53218 11.1242 7.53218C9.74197 7.53218 9.16757 8.51634 9.16757 10.0639V14.6833H6.24067V5.14822V5.14822ZM1.22177 14.5589H4.14867V5.02382H1.22177V14.5589V14.5589ZM4.56795 1.91473C4.56806 2.16005 4.5194 2.40296 4.42481 2.62932C4.33022 2.85568 4.19159 3.06098 4.01696 3.23329C3.6631 3.58498 3.18412 3.78183 2.68522 3.78062C2.1872 3.78029 1.70933 3.58394 1.35494 3.23403C1.18095 3.06113 1.04278 2.85559 0.948357 2.6292C0.853934 2.40281 0.805111 2.16002 0.804688 1.91473C0.804688 1.41935 1.00225 0.945191 1.35568 0.595427C1.70975 0.245046 2.18782 0.0486092 2.68595 0.0488283C3.18499 0.0488283 3.66354 0.245662 4.01696 0.595427C4.36965 0.945191 4.56795 1.41935 4.56795 1.91473Z"
                                    fill="white"
                                />
                            </svg>
                        </LinkedinShareButton>
                    </div>
                    <div className="w-[30px] h-[30px] rounded-full flex justify-center items-center border border-[#EE00C6] cursor-pointer">
                        <InstapaperShareButton url={shareUrl} quote={"Ulalive"}>
                            <svg
                                width="16"
                                height="15"
                                viewBox="0 0 16 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11.1215 0.0488281H5.21667C4.06289 0.050184 2.95676 0.509173 2.14098 1.32509C1.3252 2.14101 0.866396 3.24721 0.865234 4.40099L0.865234 10.3058C0.86659 11.4596 1.32558 12.5657 2.1415 13.3815C2.95741 14.1973 4.06362 14.6561 5.2174 14.6573H11.1222C12.276 14.6559 13.3821 14.1969 14.1979 13.381C15.0137 12.5651 15.4725 11.4589 15.4737 10.3051V4.40026C15.4723 3.24648 15.0133 2.14035 14.1974 1.32457C13.3815 0.508793 12.2753 0.04999 11.1215 0.0488281V0.0488281ZM14.0044 10.3051C14.0044 10.6837 13.9298 11.0586 13.785 11.4083C13.6401 11.7581 13.4277 12.0759 13.16 12.3436C12.8923 12.6113 12.5745 12.8237 12.2247 12.9686C11.875 13.1134 11.5001 13.188 11.1215 13.188H5.21667C4.4522 13.1878 3.71911 12.884 3.17862 12.3434C2.63813 11.8027 2.33449 11.0696 2.33449 10.3051V4.40026C2.33469 3.6358 2.63851 2.9027 3.17914 2.36221C3.71976 1.82172 4.45293 1.51809 5.2174 1.51809H11.1222C11.8867 1.51828 12.6198 1.8221 13.1603 2.36273C13.7008 2.90336 14.0044 3.63653 14.0044 4.40099V10.3058V10.3051Z"
                                    fill="url(#paint0_linear_7956_17178)"
                                />
                                <path
                                    d="M8.16767 3.5752C7.16629 3.57674 6.20637 3.97528 5.49835 4.68344C4.79033 5.39159 4.39198 6.35159 4.39062 7.35298C4.39179 8.35462 4.79015 9.31491 5.49835 10.0232C6.20655 10.7316 7.16676 11.1301 8.16841 11.1315C9.17017 11.1303 10.1306 10.7319 10.8389 10.0235C11.5473 9.31515 11.9458 8.35474 11.9469 7.35298C11.9454 6.35134 11.5466 5.3912 10.8382 4.68313C10.1297 3.97507 9.16931 3.57689 8.16767 3.57593V3.5752ZM8.16767 9.66223C7.55542 9.66223 6.96823 9.41901 6.5353 8.98608C6.10237 8.55315 5.85915 7.96596 5.85915 7.35371C5.85915 6.74145 6.10237 6.15427 6.5353 5.72134C6.96823 5.2884 7.55542 5.04519 8.16767 5.04519C8.77993 5.04519 9.36711 5.2884 9.80004 5.72134C10.233 6.15427 10.4762 6.74145 10.4762 7.35371C10.4762 7.96596 10.233 8.55315 9.80004 8.98608C9.36711 9.41901 8.77993 9.66223 8.16767 9.66223V9.66223Z"
                                    fill="url(#paint1_linear_7956_17178)"
                                />
                                <path
                                    d="M8.16767 3.5752C7.16629 3.57674 6.20637 3.97528 5.49835 4.68344C4.79033 5.39159 4.39198 6.35159 4.39062 7.35298C4.39179 8.35462 4.79015 9.31491 5.49835 10.0232C6.20655 10.7316 7.16676 11.1301 8.16841 11.1315C9.17017 11.1303 10.1306 10.7319 10.8389 10.0235C11.5473 9.31515 11.9458 8.35474 11.9469 7.35298C11.9454 6.35134 11.5466 5.3912 10.8382 4.68313C10.1297 3.97507 9.16931 3.57689 8.16767 3.57593V3.5752ZM8.16767 9.66223C7.55542 9.66223 6.96823 9.41901 6.5353 8.98608C6.10237 8.55315 5.85915 7.96596 5.85915 7.35371C5.85915 6.74145 6.10237 6.15427 6.5353 5.72134C6.96823 5.2884 7.55542 5.04519 8.16767 5.04519C8.77993 5.04519 9.36711 5.2884 9.80004 5.72134C10.233 6.15427 10.4762 6.74145 10.4762 7.35371C10.4762 7.96596 10.233 8.55315 9.80004 8.98608C9.36711 9.41901 8.77993 9.66223 8.16767 9.66223V9.66223Z"
                                    fill="url(#paint2_linear_7956_17178)"
                                />
                                <path
                                    d="M11.9539 4.50847C12.4538 4.50847 12.8591 4.10324 12.8591 3.60336C12.8591 3.10348 12.4538 2.69824 11.9539 2.69824C11.4541 2.69824 11.0488 3.10348 11.0488 3.60336C11.0488 4.10324 11.4541 4.50847 11.9539 4.50847Z"
                                    fill="url(#paint3_linear_7956_17178)"
                                />
                                <path
                                    d="M11.9539 4.50847C12.4538 4.50847 12.8591 4.10324 12.8591 3.60336C12.8591 3.10348 12.4538 2.69824 11.9539 2.69824C11.4541 2.69824 11.0488 3.10348 11.0488 3.60336C11.0488 4.10324 11.4541 4.50847 11.9539 4.50847Z"
                                    fill="url(#paint4_linear_7956_17178)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_7956_17178"
                                        x1="15.5911"
                                        y1="-0.865979"
                                        x2="2.42046"
                                        y2="14.7742"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#9E64F8" />
                                        <stop
                                            offset="0.24999"
                                            stopColor="#C70BDA"
                                        />
                                        <stop
                                            offset="0.406246"
                                            stopColor="#EE00C6"
                                        />
                                        <stop
                                            offset="0.510417"
                                            stopColor="#FD007A"
                                        />
                                        <stop
                                            offset="0.635422"
                                            stopColor="#FE077A"
                                        />
                                        <stop
                                            offset="0.791679"
                                            stopColor="#FD9705"
                                        />
                                        <stop offset="1" stopColor="#FDD11F" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear_7956_17178"
                                        x1="8.16877"
                                        y1="3.5752"
                                        x2="8.16877"
                                        y2="11.1315"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#9E64F8" />
                                        <stop
                                            offset="0.24999"
                                            stopColor="#C70BDA"
                                        />
                                        <stop
                                            offset="0.406246"
                                            stopColor="#EE00C6"
                                        />
                                        <stop
                                            offset="0.510417"
                                            stopColor="#FD007A"
                                        />
                                        <stop
                                            offset="0.635422"
                                            stopColor="#FE077A"
                                        />
                                        <stop
                                            offset="0.791679"
                                            stopColor="#FD9705"
                                        />
                                        <stop offset="1" stopColor="#FDD11F" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint2_linear_7956_17178"
                                        x1="12.0077"
                                        y1="3.10201"
                                        x2="5.19508"
                                        y2="11.192"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#9E64F8" />
                                        <stop
                                            offset="0.24999"
                                            stopColor="#C70BDA"
                                        />
                                        <stop
                                            offset="0.406246"
                                            stopColor="#EE00C6"
                                        />
                                        <stop
                                            offset="0.510417"
                                            stopColor="#FD007A"
                                        />
                                        <stop
                                            offset="0.635422"
                                            stopColor="#FE077A"
                                        />
                                        <stop
                                            offset="0.791679"
                                            stopColor="#FD9705"
                                        />
                                        <stop offset="1" stopColor="#FDD11F" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint3_linear_7956_17178"
                                        x1="11.9539"
                                        y1="2.69824"
                                        x2="11.9539"
                                        y2="4.50847"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#9E64F8" />
                                        <stop
                                            offset="0.24999"
                                            stopColor="#C70BDA"
                                        />
                                        <stop
                                            offset="0.406246"
                                            stopColor="#EE00C6"
                                        />
                                        <stop
                                            offset="0.510417"
                                            stopColor="#FD007A"
                                        />
                                        <stop
                                            offset="0.635422"
                                            stopColor="#FE077A"
                                        />
                                        <stop
                                            offset="0.791679"
                                            stopColor="#FD9705"
                                        />
                                        <stop offset="1" stopColor="#FDD11F" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint4_linear_7956_17178"
                                        x1="12.8736"
                                        y1="2.58488"
                                        x2="11.2415"
                                        y2="4.52296"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#9E64F8" />
                                        <stop
                                            offset="0.24999"
                                            stopColor="#C70BDA"
                                        />
                                        <stop
                                            offset="0.406246"
                                            stopColor="#EE00C6"
                                        />
                                        <stop
                                            offset="0.510417"
                                            stopColor="#FD007A"
                                        />
                                        <stop
                                            offset="0.635422"
                                            stopColor="#FE077A"
                                        />
                                        <stop
                                            offset="0.791679"
                                            stopColor="#FD9705"
                                        />
                                        <stop offset="1" stopColor="#FDD11F" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </InstapaperShareButton>
                    </div>
                </div>

                <p>Or copy link</p>
            </div>

            <div className="relative">
                <input
                    type="text"
                    id={"sharingInsatntUrl1"}
                    className="py-[13px] pl-[45px] w-full rounded-md border border-black-10 text-sm sm:text-sm"
                    value={shareUrl}
                    readOnly
                />
                <div className="absolute top-2/4 -translate-y-2/4 w-full flex justify-between items-center pl-[23px] pr-2">
                    <span>
                        <svg
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.21895 6.28105C7.17755 5.23965 5.48911 5.23965 4.44772 6.28105L1.78105 8.94772C0.73965 9.98911 0.73965 11.6776 1.78105 12.719C2.82245 13.7603 4.51089 13.7603 5.55228 12.719L6.28666 11.9846M5.78105 8.71895C6.82245 9.76035 8.51089 9.76035 9.55228 8.71895L12.219 6.05228C13.2603 5.01089 13.2603 3.32245 12.219 2.28105C11.1776 1.23965 9.48911 1.23965 8.44772 2.28105L7.71464 3.01412"
                                stroke="black"
                                strokeOpacity="0.5"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(shareUrl);
                            toastr.info(
                                "Link copied to clipboard",
                                "Share url"
                            );
                        }}
                        className="text-sm font-bold text-white rounded-md py-[9px] px-[13px] bg-purple-color capitalize"
                    >
                        copy
                    </button>
                </div>
            </div>

            {heading == "Share" && (
                <>
                    <p className="text-sm font-medium text-black-80 my-2.5">
                        Or embed to your website
                    </p>

                    <div className="relative">
                        <textarea
                            rows={4}
                            type="text"
                            id="sharingEmbedUrl"
                            className="py-[13px] pl-[45px] w-full rounded-md border border-black-10 text-sm sm:text-sm"
                            value={`<iframe src="${shareUrl + "#embed"
                                }" width="640" height="480" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`}
                            readOnly
                        ></textarea>
                        <div className="absolute top-2/4 -translate-y-2/4 w-full flex justify-between items-center pl-[23px] pr-2">
                            <span>
                                <svg
                                    width="14"
                                    height="15"
                                    viewBox="0 0 14 15"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.21895 6.28105C7.17755 5.23965 5.48911 5.23965 4.44772 6.28105L1.78105 8.94772C0.73965 9.98911 0.73965 11.6776 1.78105 12.719C2.82245 13.7603 4.51089 13.7603 5.55228 12.719L6.28666 11.9846M5.78105 8.71895C6.82245 9.76035 8.51089 9.76035 9.55228 8.71895L12.219 6.05228C13.2603 5.01089 13.2603 3.32245 12.219 2.28105C11.1776 1.23965 9.48911 1.23965 8.44772 2.28105L7.71464 3.01412"
                                        stroke="black"
                                        strokeOpacity="0.5"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigator.clipboard.writeText(
                                        `<iframe src="${shareUrl + "#embed"
                                        }" width="640" height="480" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`
                                    );
                                    toastr.info(
                                        "Code Copied to clipboard",
                                        "Embed Code"
                                    );
                                }}
                                className="text-sm font-bold text-white rounded-md py-[9px] px-[13px] bg-purple-color capitalize"
                            >
                                copy
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
